import "js-cookie";
export function gridViewExpand() {
    const grids = document.querySelectorAll('[data-js-grid-view]');
    if (grids.length) {
        const productTiles = document.querySelectorAll('.product-col');
        const cookie = Cookies.get('cs_display-modes');
        const toggleClasses = (target) => {
            for (var i=0; i < productTiles.length; i++) {
                if (target.currentTarget.dataset.jsGridView == 'expand') {
                    
                    if (window.innerWidth > 1199) {
                        productTiles[i].classList.replace("col-lg-4", "col-lg-3");
                    } else {
                        productTiles[i].classList.replace("col-xs-6", "col-xs-12");
                    }
                } else {
                    if (window.innerWidth > 1199) {
                        productTiles[i].classList.replace("col-lg-3", "col-lg-4");
                    } else {
                        productTiles[i].classList.replace("col-xs-12", "col-xs-6");
                    }
                }
            }
        }

        grids.forEach(item => {
            item.addEventListener('click', (e) => {
                if (e.currentTarget.dataset.jsGridView == 'expand') {
                    Cookies.set('cs_display-modes', 'expanded', {expires: 7, path: '/'});
                } else {
                    Cookies.remove('cs_display-modes', { path: '/' });
                }          
                toggleClasses(e);

                grids.forEach(function(item) {
                    item.classList.remove('_active')
                });
                item.classList.add('_active');
                
            });
        });
        
        if (cookie !== undefined && cookie == 'expanded') {
            for (var i=0; i < productTiles.length; i++) {
                if (window.innerWidth > 1199) {
                    productTiles[i].classList.replace("col-lg-4", "col-lg-3");
                } else {
                    productTiles[i].classList.replace("col-xs-6", "col-xs-12");
                }
            }
            grids.forEach(item => {
                if (item.dataset.jsGridView == 'expand') {
                    item.classList.add('_active');
                } else {
                    item.classList.remove('_active');
                }
            });
        }
    }
}

gridViewExpand();